<template>
  <div id="login">
    <img class="top-logo" src="http://img.tutubox.cn/LoginBg.png" alt>
     <!-- <van-tabs v-model="tabIndex" >  -->
       <!-- <van-tab title="验证码登录">  -->
        <van-cell-group v-if="isCodeLogin">
          <van-field
            type="tel"
            v-model="formCode.mobile"            
            placeholder="手机号:"
          >
            <span slot="left-icon">
              <i class="iconfont icon-shouji"></i>
            </span>
          </van-field>

          <van-field v-model="formCode.captcha"  placeholder="图文验证码:" >
            <span slot="left-icon">
              <i class="iconfont icon-tuwenyanzheng"></i>
            </span>
            <img slot="button" :src="formCode.source" @click="captcha">
          </van-field>

          <van-field v-model="formLogin[0].code" placeholder="手机验证码:">
            <span slot="left-icon">
              <i class="iconfont icon-yanzhengma"></i>
            </span>
            <van-button
              id="button-code"
              slot="button"
              size="small"
              type="primary"
              @click="code"
              :disabled="smsCode.count > 0"
            >{{ smsCode.text }}</van-button>
          </van-field>
        </van-cell-group>
      <!-- </van-tab> -->
      <!-- <van-tab> -->
       <van-cell-group v-else> 
          <van-field
            v-model="formLogin[1].account"
            placeholder="请输入账号"
          >
            <span slot="left-icon">
              <i class="iconfont icon-shouji"></i>
            </span>
          </van-field>
          <van-field
            v-model="formLogin[1].password"
            type="password"
            placeholder="请输入密码"
          > 
            <span slot="left-icon">
              <i class="iconfont icon-mima"></i>
            </span>
          </van-field>

        </van-cell-group>
      <!-- </van-tab> -->
    <!-- </van-tabs> -->
    <van-button id="button-login" type="default" bottom-action @click="login">登 录</van-button>
    <div class="code-login" v-if="!isCodeLogin" @click="switchLogin">短信验证码登录</div>
    <div class="code-login" v-else @click="switchLogin">账号密码登录</div>
    <!-- <div class="bottom-logo">
      <span class="left-border"></span>
      <img :src="logo" alt="">
      <span class="right-border"></span>
    </div> -->
  </div>
</template>

<script>
import store from "@/store";
import { getToken, setToken } from "@/utils/auth";
import { Tab, Tabs, CellGroup, Field, Toast, Button, Dialog } from "vant";
import logo from '@/assets/gemlogo.png'
export default {
  name: "Login",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      tabIndex: 1,
      formLogin: [
        {
          mobile: "",
          code: ""
        },
        {
          account: "", //'15889933997',
          password: "" //'1234567'
        }
      ],
      formCode: {
        mobile: "",
        template: "login",
        captcha_id: "",
        captcha: "",
        source: null
      },
      smsCode: {
        count: 0,
        text: "发送验证码",
        interval: null
      },
      loading: false,
      token: this.$route.params.token,
      logo,
      isCodeLogin: false
    };
  },
  methods: {
    // 图形验证码
    captcha() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$http
        .get("/captcha?v=" + Date.parse(new Date()))
        .then(data => {
          this.formCode.captcha_id = data.id;
          this.formCode.source = data.captcha;
          this.formCode.captcha = "";
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 发送短信验证码
    code() {
      if (!/^1((3|5|8){1}\d{1}|70|99)\d{8}$/.test(this.formCode.mobile)) {
        Toast("请正确填写手机号~");
        return;
      }
      if (!/\d{3,4}/.test(this.formCode.captcha)) {
        Toast("请正确填写图形验证码~");
        return;
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$http
        .post("/sms/code", this.formCode)
        .then(() => {
          this.count();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 验证码倒计时
    count() {
      this.smsCode.count = 60;
      this.smsCode.text = "发送中...";
      this.smsCode.interval = setInterval(() => {
        this.smsCode.count--;
        if (this.smsCode.count) {
          this.smsCode.text = `重新发送(${this.smsCode.count}s)`;
        } else {
          clearInterval(this.smsCode.interval);
          this.smsCode.text = "发送验证码";
        }
      }, 1000);
    },
    // 登录
    login() {
      switch (this.tabIndex) {
        case 0: {
          if (!/^1((3|5|8){1}\d{1}|70|99)\d{8}$/.test(this.formCode.mobile)) {
            Toast("请正确填写手机号~");
            return;
          }
          if (!/\d{4,6}/.test(this.formLogin[0].code)) {
            Toast("请正确填写短信验证码~");
            return;
          }
          break;
        }
        case 1: {
          if (
            !/^1((3|5|8){1}\d{1}|70|99)\d{8}$/.test(this.formLogin[1].account)
          ) {
            Toast("请正确填写账号~");
            return;
          }
          if (!/\w{6,22}/.test(this.formLogin[1].password)) {
            Toast("请正确填写密码~");
            return;
          }
          break;
        }
      }

      if (this.loading) {
        return;
      }
      this.loading = true;
      this.formLogin[0].mobile = this.formCode.mobile;
      this.$http
        .post("/user/login", this.formLogin[this.tabIndex])
        .then(data => {
          this.loading = false;
          setToken(data.token);

          if (this.$isWeChat && this.token) {
            Dialog.confirm({
              message: "是否绑定当前微信？"
            })
              .then(() => {
                this.$http
                  .post("/user/binding_wechat")
                  .then(() => {
                    Toast("绑定成功~");
                    this.loginRedirect(data);
                  })
                  .catch(() => {
                    this.loginRedirect(data);
                  });
              })
              .catch(() => {
                this.loginRedirect(data);
              });
          }
          this.loginRedirect(data);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    autoLogin() {
      if (this.$isWeChat) {
        this.$http.post("/user/login_wechat").then(data => {
          this.loginRedirect(data);
        });
      }
    },
    loginRedirect(data) {
      setToken(data.token);
      store.dispatch("RefreshUserInfo");

      if (data.imperfect) {
        this.$router.replace("/user/edit/imperfect");
      } else if (this.$route.query.r) {
        this.$router.replace(this.$route.query.r.replace(/#/, ""));
      } else {
        this.$router.replace("/");
      }
    },
    switchLogin() {
      this.isCodeLogin = !this.isCodeLogin;
      if(this.isCodeLogin) {
        this.tabIndex = 0
      }else {
        this.tabIndex = 1
      }
    }
  },
  created() {
    if (this.$isWeChat) {
      if (this.token) {
        this.autoLogin();
        // } else {
        //   window.location.href = '/wechat/auth?snsapi=userinfo&targetUrl=/wechat/login/auto-register';
      }
      return;
    }
    this.captcha();
  }
};
</script>

<style scoped lang="less">
#login {
  text-align: center;
  // position: relative;
  .top-logo {
    width: 100%;
    margin-bottom: 20px;
  }

  // /deep/ .van-tabs__wrap::after {
  //   border: none;
  // }
  // /deep/ .van-tab {
  //   color: #e5e5e5;
  //   font-size: 22px;
  // }
  // /deep/ .van-tab--active {
  //   color: black;
  // }
  // /deep/ .van-tabs__line {
  //   display: none;
  // }
  // /deep/ .van-tabs__content {
  //   padding-top: 30px;
  // }

  // /deep/ .van-cell {
  //     display: block;
  //     position: relative;
  // }
  // /deep/ .van-cell__title {
  //     text-align: left;
  // }
  // /deep/ .van-cell__value {
  //     overflow: visible;
  //     margin-top: 10px;
  // }
  // /deep/ .van-field__button {
  //     position: absolute;
  //     bottom: 10px;
  //     right: 10px;
  // }
  .van-cell-group {
    padding: 0 20px;
    .van-cell::after {
      content: ' ';
      position: absolute;
      pointer-events: none;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      left: 15px;
      right: 0;
      bottom: 0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
      border-bottom: 1px solid #ebedf0;
    }
    .iconfont{
      font-size: 16px;
      color: rgba(88,68,190,1);
    }
  }
  /deep/ .van-hairline--top-bottom::after {
    border-width: 0 0;
  }
  /deep/.van-cell{
    line-height: 35px;
  }
  #button-code {
    color: black;
    background-color: white;
    border-radius: 0;
    border: 1px solid black;
  }
  #button-login {
    width: 90%;
    margin-top: 50px;
    background:rgba(119,97,207,1);
    box-shadow:7px 12px 23px 0px rgba(47,45,54,0.16);
    border-radius:5px;
  }
  .code-login{
    margin-top: 20px;
    font-size: 14px;
    font-weight:400;
    color:rgba(119,97,207,1);
  }
  // .bottom-logo{
  //   position: relative;
  //   margin-top: 40px;
  //   img{
  //     width:25%;
  //   }
  //   .left-border{
  //     display: inline-block;
  //     width: 60px;
  //     border-top: 1px solid  rgba(88,68,190,1);
  //     position: absolute;
  //     top: 50%;
  //     left: 20%;
  //   }
  //   .right-border{
  //     display: inline-block;
  //     width: 60px;
  //     border-top: 1px solid  rgba(88,68,190,1);
  //     position: absolute;
  //     top: 50%;
  //     right: 20%;
  //   }
  // }
}
</style>
